import { AvField, AvForm } from "availity-reactstrap-validation";
import { Button, Col, Row } from "react-bootstrap";
import { Translate } from "../../../../Enums/Tranlate";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import AttendanceService from "../../../../../services/HRM/AttendanceService";

const FingerprintSettings = () => {
	const [formData, setFormData] = useState({
		allowance_time_from_clock_in: "",
		deduction: [{ delaying_time: "", number_of_repating: "", deduction: "" }],
	});
	const lang = useSelector((state) => state.auth.lang);
	const numberOfRepatingOptions = [
		{ label: Translate[lang].first_time, value: 1 },
		{ label: Translate[lang].second_time, value: 2 },
		{ label: Translate[lang].third_time, value: 3 },
		{ label: Translate[lang].fourth_time, value: 4 },
		{ label: Translate[lang].fifth_time, value: 5 },
	];
	const attendanceService = new AttendanceService();
	const deductionOptions = [
		{ label: "10%", value: 10 },
		{ label: "15%", value: 15 },
		{ label: "20%", value: 20 },
		{ label: "25%", value: 25 },
		{ label: "50%", value: 50 },
		{ label: "75%", value: 75 },
		{ label: "100%", value: 100 },
	];
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		attendanceService?.getFingerprintSettings().then((res) => {
			if (res?.status) {
				const response = res?.data?.data;
				setFormData({
					id: response?.id,
					allowance_time_from_clock_in: response?.allowanceTimeMinutes,
					deduction: response?.deductions?.map((item) => {
						return {
							delaying_time: item?.delayingTimeMinutes,
							number_of_repating: numberOfRepatingOptions?.find(
								(res) => res?.value === Number(item?.occurrence),
							),
							deduction: deductionOptions?.find(
								(res) => res?.value === Number(item?.deductionPercentage),
							),
						};
					}),
				});
			}
		});
	}, []);

	const submit = (e) => {
		e.preventDefault();
		let data = {
			allowanceTimeMinutes: Number(formData?.allowance_time_from_clock_in),
			isActive: true,
			deductions: formData?.deduction?.map((res) => ({
				delayingTimeMinutes: Number(res?.delaying_time),
				occurrence: Number(res?.number_of_repating?.value),
				deductionPercentage: res?.deduction?.value,
			})),
		};

		setLoading(true);
		attendanceService
			.updateFingerprintSettings(formData?.id, data)
			?.then((res) => {
				if (res && res?.status) {
					toast.success("Fingerprint Settings Updated Successfully");
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	};
	return (
		<AvForm className="form-horizontal" onValidSubmit={submit}>
			<Row>
				<Col md={6}>
					<AvField
						label={Translate[lang]?.allowance_time_from_clock_in}
						type="number"
						placeholder={Translate[lang]?.minuts}
						bsSize="lg"
						min="1"
						name="allowance_time_from_clock_in"
						validate={{
							required: {
								value: true,
								errorMessage: Translate[lang].field_required,
							},
						}}
						value={formData.allowance_time_from_clock_in}
						onChange={(e) =>
							setFormData({
								...formData,
								allowance_time_from_clock_in: e.target.value,
							})
						}
					/>
				</Col>
				<Col md={6}></Col>

				{/*
				<Col md={12}>
					<AvField
						label={Translate[lang]?.clocked_out}
						type="time"
						placeholder={Translate[lang]?.clocked_out}
						bsSize="lg"
						name="clocked_out"
						validate={{
							required: {
								value: true,
								errorMessage: Translate[lang].field_required,
							},
						}}
						value={formData.clocked_out}
						onChange={(e) =>
							setFormData({ ...formData, clocked_out: e.target.value })
						}
					/>
				</Col> */}
			</Row>
			<div
				className="p-3"
				style={{ border: "1px solid #dedede", borderRadius: "15px" }}>
				<p className="text-black fw-500">{Translate[lang]?.deduction}</p>
				{formData?.deduction?.map((info, index) => {
					return (
						<div key={index} className="d-flex " style={{ gap: "12px" }}>
							<Row style={{ width: "-webkit-fill-available" }}>
								<Col md={4}>
									<AvField
										label={Translate[lang]?.delaying_time}
										type="number"
										placeholder={Translate[lang]?.minuts}
										bsSize="lg"
										min="1"
										name={`delaying_time${index}`}
										validate={{
											required: {
												value: true,
												errorMessage: Translate[lang].field_required,
											},
										}}
										value={info.delaying_time}
										onChange={(e) => {
											let update = formData?.deduction?.map((res, ind) =>
												ind === index
													? { ...res, delaying_time: e.target?.value }
													: res,
											);
											setFormData({ ...formData, deduction: update });
										}}
									/>
								</Col>
								<Col md={4} className="mb-3">
									<label className="text-label">
										{Translate[lang]?.number_of_repating}
									</label>
									<Select
										value={info?.number_of_repating}
										name={`number_of_repating${index}`}
										placeholder={Translate[lang]?.select}
										options={numberOfRepatingOptions}
										onChange={(e) => {
											let update = formData?.deduction?.map((res, ind) =>
												ind === index ? { ...res, number_of_repating: e } : res,
											);
											setFormData({ ...formData, deduction: update });
										}}
									/>
								</Col>
								<Col md={4} className="mb-3">
									<label className="text-label">
										{Translate[lang]?.deduction}
									</label>
									<Select
										value={info?.deduction}
										name={`deduction${index}`}
										placeholder={Translate[lang]?.select}
										options={deductionOptions}
										onChange={(e) => {
											let update = formData?.deduction?.map((res, ind) =>
												ind === index ? { ...res, deduction: e } : res,
											);
											setFormData({ ...formData, deduction: update });
										}}
									/>
								</Col>
							</Row>
							{index === 0 ? (
								<div className="d-flex align-items-center">
									<i
										className="fa fa-plus fs-22 mt-2 cursor-pointer text-primary"
										style={{
											border: "2px solid var(--primary)",
											borderRadius: "50%",
											height: "fit-content",
											padding: "0px 8px",
										}}
										onClick={() =>
											setFormData({
												...formData,
												deduction: [
													...formData.deduction,
													{
														delaying_time: "",
														number_of_repating: "",
														deduction: "",
													},
												],
											})
										}
									/>
								</div>
							) : (
								<div className="d-flex align-items-center">
									<i
										className="fa fa-minus fs-22 mt-2 cursor-pointer text-danger"
										style={{
											border: "2px solid var(--danger)",
											borderRadius: "50%",
											height: "fit-content",
											padding: "0px 8px",
										}}
										onClick={() => {
											let update = formData?.deduction?.filter(
												(_, ind) => ind !== index,
											);
											setFormData({
												...formData,
												deduction: [...update],
											});
										}}
									/>
								</div>
							)}
						</div>
					);
				})}
			</div>
			<Button
				variant="primary"
				className="w-50 mt-3"
				type="submit"
				disabled={loading}>
				{Translate[lang]?.save}
			</Button>
		</AvForm>
	);
};
export default FingerprintSettings;
